import { AbstractControl, ValidationErrors } from '@angular/forms';

export const TldValidator = (control: AbstractControl): ValidationErrors | null => {
  return !/.*@.+\..+/.test(control.value) ? { tld_missing: { value: control.value } } : null;
};
